export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/entertainment.9022660.svg";